import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface TagIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const TagIcon = ({
  color = 'textPrimary',
  size = 16,
  ...props
}: TagIconProps) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill={colors[color]}
        d="M9.24407 0.0164004C8.62415 -0.0630765 8.00239 0.149159 7.56045 0.591096L0.591079 7.56047C-0.197026 8.34857 -0.197026 9.62634 0.591079 10.4144L5.58555 15.4089C6.37366 16.197 7.65143 16.197 8.43953 15.4089L15.4089 8.43955C15.8508 7.99761 16.0631 7.37585 15.9836 6.75593L15.416 2.32901C15.2992 1.41799 14.582 0.700752 13.671 0.583954L9.24407 0.0164004ZM10.2223 5.77668C10.8134 6.36776 11.7717 6.36776 12.3628 5.77668C12.9538 5.1856 12.9538 4.22727 12.3628 3.63619C11.7717 3.04511 10.8134 3.04511 10.2223 3.63619C9.6312 4.22727 9.6312 5.1856 10.2223 5.77668Z"
      />
    </Svg>
  );
};
